import $ from 'jquery'

export function init() {
  $('.content table').each(function () {
    const $headerColumns = $(this).find('thead th')

    // Apply column header text as attributes to all columns for mobile layout
    const headerColumnText = []
    $headerColumns.each((i, col) => headerColumnText.push($(col).text()))
    $(this)
      .find('tbody tr')
      .each((r, row) => {
        $(row)
          .find('td')
          .each((c, col) => {
            const columnText = $(col).text()
            const columnHeaderText = headerColumnText[c]
            if (!!columnHeaderText && !!columnText) $(col).attr('data-column-text', columnHeaderText + ' ')
          })
      })

    // If a header column has an align class, apply to all columns below
    $headerColumns.each((i, col) => {
      const colClass = $(col).attr('class') || ''
      const found = colClass.match(/(text\-[a-zA-Z0-9\-\_]+)/g)
      if (found)
        $(this)
          .find('tbody tr td:nth-child(' + (i + 1) + ')')
          .addClass(found[0])
    })
  })
}
